const langKey = 'alias_new_lang';

const all_langs = ['en', 'ru'];
export const loadLang = () => {
    const stored = localStorage.getItem(langKey);
    if (stored && all_langs.includes(stored)) {
        return stored;
    }
    return 'en';
}

export const saveLang = (lang) => {
    localStorage.setItem(langKey, lang);
}